import styled from 'styled-components'

const RelatedPagesStyle = styled.div`
    --rpContTitleMarginBottom: var(--sp9x);
    --rpImageProportion: 85.64%;
    --rpInfoMargin: var(--sp10x);
    --rpInfoPadding: var(--sp8x);
    --rpInfoTitleMarginBottom: var(--sp3x);
    --rpInfoDescriptionMarginBottom: var(--sp8x);

    .related-pages-title {
        margin-bottom: var(--rpContTitleMarginBottom);
    }

    .related-item-cont {
        .related-item {
            display: block;
            position: relative;
            border-radius: var(--sp2x);
            overflow: hidden;

            .imageCont {
                --imagePaddingTop: var(--rpImageProportion);
            }

            .related-item-info {
                display: flex;
                flex-direction: column;
                position: absolute;
                left: var(--rpInfoMargin);
                right: var(--rpInfoMargin);
                bottom: var(--rpInfoMargin);
                max-height: calc(100% - 2 * var(--rpInfoMargin));
                padding: var(--rpInfoPadding);
                border-radius: var(--sp2x);
                z-index: 1;

                &-title {
                    margin-bottom: var(--rpInfoTitleMarginBottom);
                }

                &-description {
                    display: -webkit-box;
                    margin-bottom: var(--rpInfoDescriptionMarginBottom);
                    flex: 1;
                    overflow: hidden;
                    -webkit-line-clamp: 4;
                    -webkit-box-orient: vertical;
                }
            }
        }
    }

    @media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
        --rpContTitleMarginBottom: var(--sp8x);
        --rpImageProportion: 85.71%;
        --rpInfoMargin: var(--sp8x);
        --rpInfoPadding: var(--sp6x);
        --rpInfoTitleMarginBottom: var(--sp3x);
        --rpInfoDescriptionMarginBottom: var(--sp6x);
    }

    @media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
        --rpContTitleMarginBottom: var(--sp6x);
        --rpImageProportion: 85.76%;
        --rpInfoMargin: var(--sp5x);
        --rpInfoPadding: var(--sp5x);
        --rpInfoTitleMarginBottom: var(--sp2x);
        --rpInfoDescriptionMarginBottom: var(--sp5x);
    }

    @media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
        --rpContTitleMarginBottom: var(--sp6x);
        --rpImageProportion: 85.71%;
        --rpInfoMargin: var(--sp4x);
        --rpInfoPadding: var(--sp4x);
        --rpInfoTitleMarginBottom: var(--sp2x);
        --rpInfoDescriptionMarginBottom: var(--sp4x);
    }

    @media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
        --rpContTitleMarginBottom: var(--sp5x);
        --rpImageProportion: 85.68%;
        --rpInfoMargin: var(--sp2x);
        --rpInfoPadding: var(--sp4x);
        --rpInfoTitleMarginBottom: var(--sp2x);
        --rpInfoDescriptionMarginBottom: var(--sp4x);
    }

    @media (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
        --rpContTitleMarginBottom: var(--sp5x);
        --rpContMarginBottom: var(--sp4x);
        --rpImageProportion: 49.88%;
        --rpInfoWidth: 54.66%;
        --rpInfoMargin: var(--sp2x);
        --rpInfoPadding: var(--sp4x);
        --rpInfoTitleMarginBottom: var(--sp2x);
        --rpInfoDescriptionMarginBottom: var(--sp4x);

        .related-item-cont {
            &:not(:last-child) {
                margin-bottom: var(--rpContMarginBottom);
            }

            .related-item {
                .related-item-info {
                    width: var(--rpInfoWidth);
                    left: unset;
                }
            }
        }
    }

    @media (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
        --rpContTitleMarginBottom: var(--sp5x);
        --rpContMarginBottom: var(--sp4x);
        --rpImageProportion: 49.88%;
        --rpInfoWidth: 54.43%;
        --rpInfoMargin: var(--sp2x);
        --rpInfoPadding: var(--sp4x);
        --rpInfoTitleMarginBottom: var(--sp2x);
        --rpInfoDescriptionMarginBottom: var(--sp2x);

        .related-item-cont {
            &:not(:last-child) {
                margin-bottom: var(--rpContMarginBottom);
            }

            .related-item {
                .related-item-info {
                    width: var(--rpInfoWidth);
                    left: unset;
                    top: var(--rpInfoMargin);

                    &-description {
                        -webkit-line-clamp: 6;
                    }
                }
            }
        }
    }

    @media (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
        --rpContTitleMarginBottom: var(--sp5x);
        --rpContMarginBottom: var(--sp4x);
        --rpInfoWidth: 100%;
        --rpInfoPadding: var(--sp4x);
        --rpInfoTitleMarginBottom: var(--sp2x);
        --rpInfoDescriptionMarginBottom: var(--sp2x);

        .related-item-cont {
            &:not(:last-child) {
                margin-bottom: var(--rpContMarginBottom);
            }

            .related-item {
                
                .related-item-info {
                    position: relative;
                    width: var(--rpInfoWidth);
                    inset: unset;

                    &-description {
                        -webkit-line-clamp: 6;
                    }
                }
            }
        }
    }
`
export default RelatedPagesStyle